import React from "react";
import LeadFromScratchContent from "../components/leads/lead-from-scratch-content";

const LeadFromScratch = () => {
  return <LeadFromScratchContent leadOrigin="qfs" />;
};

export default LeadFromScratch;
